// extracted by mini-css-extract-plugin
export default {"container":"PlayFlipGameGeneric_container__Wj-qC","fadeIn":"PlayFlipGameGeneric_fadeIn__QRxz6"};